import { FormattedMessage } from 'react-intl';
import { AccountCircleOutlined, Groups3Outlined } from '@mui/icons-material';
import { NavItemType } from '../types/menu';
import { DeepReadonly } from '../types/DeepReadonly';
import { useMemo } from 'react';
import { useOrganizationMenuItems } from './organization';
import { usePersonalMenuItems } from './personal';

export const useSettingsMenuItems = (): DeepReadonly<NavItemType>[] => {
	const personalMenuItems = usePersonalMenuItems();
	const organizationMenuItems = useOrganizationMenuItems();

	return useMemo(
		() => [
			{
				id: 'personal',
				title: <FormattedMessage id={'settings.navigation.title.personal'} />,
				type: 'collapse',
				icon: AccountCircleOutlined,
				children: personalMenuItems,
			},
			{
				id: 'organizations',
				title: <FormattedMessage id={'settings.navigation.title.organizations'} />,
				type: 'collapse',
				icon: Groups3Outlined,
				children: organizationMenuItems,
			},
		],
		[personalMenuItems, organizationMenuItems],
	);
};
